import './component.scss';
import '@stimulus/polyfills';
import { Application, Controller } from 'stimulus';
import { PrefectureDropdownController } from './controllers/prefecture_dropdown_controller';
import { CityDropdownController } from './controllers/city_dropdown_controller';

import './images/prefecture_icon.svg';
import './images/close_icon.svg';
import './images/construction_icon.svg';
import './images/left_arrow_icon.svg';
import './images/city_icon.png';
import './images/right_arrow_icon.svg';
import './images/search_icon.svg';

const app = Application.start();

class SearchPanelController extends Controller {
  static targets = [
    'prefectureInput',
    'prefectureText',
    'prefectureDropdown',
    'prefectureHiddenField',
    'cityInput',
    'cityText',
    'cityDropdown',
    'cityButtonsContainer',
    'citySelectedPill',
    'citySelectedText',
    'cityHiddenField',
    'partTypeCheckbox'
  ];

  static values = {
    form: Object
  };

  // ========================================
  // ライフサイクル
  // ========================================

  connect() {
    // コントローラーを初期化
    this.prefectureDropdownController = new PrefectureDropdownController(this);
    this.cityDropdownController = new CityDropdownController(this);

    // data属性から初期値を取得
    if (!this.formValue || Object.keys(this.formValue).length === 0) {
      this.formValue = {
        prefecture_id: null,
        prefecture_name: null,
        city_id: null,
        city_name: null,
        categories: [],
        part_types: []
      };
    }

    // 選択状態の初期化
    this.selectedPrefectureId = this.formValue.prefecture_id;
    this.selectedPrefecture = this.formValue.prefecture_name;
    this.selectedCity = this.formValue.city_id;
    this.selectedCityName = this.formValue.city_name;
    this.cities = [];

    // ドロップダウンの外側クリックでクローズ（メモリリーク防止のため参照を保持）
    this.boundHandleClickOutside = this.handleClickOutside.bind(this);
    document.addEventListener('click', this.boundHandleClickOutside);

    // 初期表示時に都道府県が選択されていれば市区町村を取得
    if (this.selectedPrefecture) {
      this.cityDropdownController.loadCities(this.selectedPrefecture);
    }
  }

  disconnect() {
    document.removeEventListener('click', this.boundHandleClickOutside);
  }

  handleClickOutside(event) {
    // クリックされた要素がドロップダウンボタンまたはドロップダウン内かどうかを確認
    const isPrefectureInput = event.target.closest('[data-refosumu-subsidies-search-panel-target="prefectureInput"]');
    const isPrefectureDropdown = event.target.closest('[data-refosumu-subsidies-search-panel-target="prefectureDropdown"]');
    const isCityInput = event.target.closest('[data-refosumu-subsidies-search-panel-target="cityInput"]');
    const isCityDropdown = event.target.closest('[data-refosumu-subsidies-search-panel-target="cityDropdown"]');

    // 都道府県ドロップダウン：ボタンとドロップダウン内以外のクリックで閉じる
    if (!isPrefectureInput && !isPrefectureDropdown) {
      this.prefectureDropdownController.closePrefectureDropdown();
    }

    // 市区町村ドロップダウン：ボタンとドロップダウン内以外のクリックで閉じる
    if (!isCityInput && !isCityDropdown) {
      this.cityDropdownController.closeCityDropdown();
    }
  }

  // ========================================
  // 都道府県ドロップダウン
  // ========================================

  togglePrefectureDropdown(event) {
    this.prefectureDropdownController.togglePrefectureDropdown(event);
  }

  selectPrefecture(event) {
    this.prefectureDropdownController.selectPrefecture(event);
  }

  // ========================================
  // 市区町村ドロップダウン
  // ========================================

  toggleCityDropdown(event) {
    this.cityDropdownController.toggleCityDropdown(event);
  }

  selectCity(event) {
    this.cityDropdownController.selectCity(event);
  }

  clearCity(event) {
    this.cityDropdownController.clearCity(event);
  }

  // ========================================
  // 工事箇所トグル
  // ========================================

  togglePartType(event) {
    const checkbox = event.currentTarget;

    if (checkbox.checked) {
      if (!this.formValue.part_types.includes(checkbox.value)) {
        this.formValue = {
          ...this.formValue,
          part_types: [...this.formValue.part_types, checkbox.value]
        };
      }
    } else {
      this.formValue = {
        ...this.formValue,
        part_types: this.formValue.part_types.filter(type => type !== checkbox.value)
      };
    }
  }
}

app.register('refosumu-subsidies-search-panel', SearchPanelController);
